export default __webpack_public_path__ + "static/media/img9.1b0f8678.png";